import { HTTP_INTERCEPTORS, HttpClientModule } from "@angular/common/http";
import { APP_INITIALIZER, NgModule } from "@angular/core";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { BreadcrumbsComponent } from "./components/breadcrumbs/breadcrumbs.component";
import { FooterComponent } from "./components/footer/footer.component";
import { HeaderComponent } from "./components/header/header.component";
import { MainFrameComponent } from "./components/main-frame/main-frame.component";
import { SidebarComponent } from "./components/sidebar/sidebar.component";
import { CollapsibleHeaderLeftSidebarLayoutComponent } from "./layouts/collapsible-header-left-sidebar-layout/collapsible-header-left-sidebar-layout.component";
import { GenericWidgetComponent } from "./components/widgets/generic-widget/generic-widget.component";
import { LoaderDirective } from "./components/widgets/loader.directive";
import { WebcontentComponent } from "./components/widgets/web-content/web-content.component";
import { FormlyWidgetModule } from "./components/widgets/forms/forms.module";
import { CommonModule } from "@angular/common";
import { IntroRedComponent } from "./components/template/models/intro-red/intro-red.component";
import { DocumentPreviewComponent } from "./components/template/models/document-preview/document-preview.component";
import { TemplateComponent } from "./components/template/template.component";
import { ComponentLoaderService } from "./miscellaneous/component-loader.service";
import { PageComponent } from "./components/page/page.component";
import { MenuComponent } from "./components/widgets/menu/menu.component";
import { TreeMenuComponent } from "./components/widgets/tree-menu/tree-menu.component";
import { ItemMenuComponent } from "./components/widgets/menu/item-menu.component";
import { SmartTableComponent } from "./components/widgets/smart-table/smart-table.component";
import { AssetPublisherComponent } from "./components/widgets/asset-publisher/asset-publisher.component";
import { CardWrapperComponent } from "./components/template/models/card-wrapper/card-wrapper.component";
import { CardFilesComponent } from "./components/template/models/card-files/card-files.component";
import { NgbCarouselModule, NgbModule, NgbToastModule, NgbAccordionModule } from "@ng-bootstrap/ng-bootstrap";
import { initializeKeycloak } from "./init/keycloak-init.factory";
import { KeycloakAngularModule, KeycloakService } from "keycloak-angular";
import { NgbdSortableHeader } from "./components/widgets/smart-table/directives/ngbd-sortable-header";
import { TabsComponent } from "./components/widgets/tabs/tabs.component";
import { FormInterceptor } from "./services/form.interceptor";
import { ToastsContainer } from "./components/main-frame/toasts-container.component"; // Import ToastsContainer here
import { BrowserModule } from "@angular/platform-browser";
import { InterceptorDataComponent } from "./components/template/models/interceptor-data/interceptor-data.component";
import { TimelineComponent } from "./components/template/models/timeline/timeline.component";
import { NoSidebarLayoutComponent } from "./layouts/no-sidebar-layout/no-sidebar-layout.component";
import { FileListComponent } from "./components/template/models/file-list/file-list.component";
import { DynamicContentComponent } from "./components/widgets/dynamic-content/dynamic-content.component";
import { ObbligoComponent } from "./components/template/models/obbligo/obbligo.component";
import { MiniCardFilesComponent } from "./components/template/models/mini-card-files/mini-card-files.component";
import { TruncatePipe } from "./miscellaneous/pipes/truncate-text.pipe";
import { HeroComponent } from './components/template/models/hero/hero.component';
import { HeroImageComponent } from './components/template/hero-image/hero-image.component';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { GroupFilesPipe } from "./components/template/models/mini-card-files/group-files.pipe";
import { IconContainerComponent } from "./components/template/icon-container/icon-container.component";
import { StructureService } from "./services/structure.service";
import { SearchComponent } from './search/search.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { CardResourceComponent } from './components/template/models/card-resource/card-resource.component';
import { AuthService } from "./services/auth.service";
import { WebcontentPublisherComponent } from './components/template/models/webcontent-publisher/webcontent-publisher.component';
import { DragDropComponent } from './components/drag-drop/drag-drop.component';
import { MatExpansionModule } from "@angular/material/expansion";
import { DragDropModule } from "@angular/cdk/drag-drop";

@NgModule({
  declarations: [
    WebcontentComponent,
    GenericWidgetComponent,
    AppComponent,
    FooterComponent,
    HeaderComponent,
    SidebarComponent,
    BreadcrumbsComponent,
    CollapsibleHeaderLeftSidebarLayoutComponent,
    MainFrameComponent,
    LoaderDirective,
    TemplateComponent,
    IntroRedComponent,
    DocumentPreviewComponent,
    PageComponent,
    MenuComponent,
    TreeMenuComponent,
    ItemMenuComponent,
    SmartTableComponent,
    AssetPublisherComponent,
    CardWrapperComponent,
    CardFilesComponent,
    NgbdSortableHeader,
    TabsComponent,
    InterceptorDataComponent,
    TimelineComponent,
    NoSidebarLayoutComponent,
    FileListComponent,
    DynamicContentComponent,
    ObbligoComponent,
    MiniCardFilesComponent,
    TruncatePipe,
    GroupFilesPipe,
    HeroComponent,
    HeroImageComponent,
    ConfirmationDialogComponent,
    IconContainerComponent,
    SearchComponent,
    CardResourceComponent,
    WebcontentPublisherComponent,
    DragDropComponent
  ],
  providers: [
    AuthService,
    StructureService,
    ComponentLoaderService,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeKeycloak,
      multi: true,
      deps: [KeycloakService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: FormInterceptor,
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
  imports: [
    NgbToastModule,
    AppRoutingModule,
    CommonModule,
    BrowserAnimationsModule,
    HttpClientModule,
    FormlyWidgetModule,
    NgbModule,
    NgbCarouselModule,
    KeycloakAngularModule,
    ToastsContainer,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    MatExpansionModule,
    DragDropModule,
    NgbAccordionModule
  ],
  exports: [],
})
export class AppModule { }
